(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-line-items"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shinora-cart-pairing')) {
    customElements.define('shinora-cart-pairing', class extends HTMLElement {
      connectedCallback() {
        if (this.pairingBound) return;
        this.pairingBound = true;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-shinora-pairing-add]');
          if (!button || !this.contains(button) || button.disabled) return;
          event.preventDefault();
          const cartItems = this.closest('cart-items');
          if (!cartItems || typeof cartItems.addToCart !== 'function') {
            window.location.assign(button.dataset.pairingUrl);
            return;
          }
          const formData = new FormData();
          formData.append('id', button.dataset.shinoraPairingAdd);
          formData.append('quantity', '1');
          window.a11y.lastElement = button;
          cartItems.addToCart(formData, button);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
